export const Y100 = '#FFF8C1';
export const Y200 = '#F9E32C';
export const Y300 = '#FFD400';
export const Y400 = '#F9B114';

export const N0 = '#FFFFFF';
export const N100 = '#F5F6F8';
export const N150 = '#C0C0C0';
export const N200 = '#E0E0E0';
export const N250 = '#CED4DA';
export const N300 = '#878786';
export const N350 = '#656870';
export const N400 = '#373736';
export const N500 = '#000000';
export const N600 = '#B23B3B';
export const N700 = '#020202';
